import Rule from './Rule';

/**
 * The ProtocolMatchingRule Class extends the Rule Class.
 *
 * At present it does not add any new methods or attributes
 * @type {ProtocolMatchingRule}
 */
class ProtocolMatchingRule extends Rule {}

/**
 * The StudyMatchingRule Class extends the Rule Class.
 *
 * At present it does not add any new methods or attributes
 * @type {StudyMatchingRule}
 */
class StudyMatchingRule extends Rule {}

/**
 * The SeriesMatchingRule Class extends the Rule Class.
 *
 * At present it does not add any new methods or attributes
 * @type {SeriesMatchingRule}
 */
class SeriesMatchingRule extends Rule {}

/**
 * The ImageMatchingRule class extends the Rule Class.
 *
 * At present it does not add any new methods or attributes
 * @type {ImageMatchingRule}
 */
class ImageMatchingRule extends Rule {}

export {
  ProtocolMatchingRule,
  StudyMatchingRule,
  SeriesMatchingRule,
  ImageMatchingRule,
};
